import { jwtDecode } from 'jwt-decode';

export interface DecodedToken {
  exp?: number;
  email?: string;
  first_name?: string;
  last_name?: string;
  [key: string]: unknown;
}

export function decodeToken(token: string): DecodedToken | null {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string | null | undefined): boolean {
  if (!token) return true;
  const decoded = decodeToken(token);
  if (!decoded?.exp) return false;
  const nowSeconds = Math.floor(Date.now() / 1000);
  return decoded.exp <= nowSeconds;
}
